import {
  GET_DATES_AWARDED,
  GET_DATES_AWARDED_ERROR,
  GET_DATES_AWARDED_SUCCESS,
  GET_SELLER_PARTNERSHIP_CERTIFICATE,
  GET_SELLER_PARTNERSHIP_CERTIFICATE_ERROR,
  GET_SELLER_PARTNERSHIP_CERTIFICATE_SUCCESS
} from './PartnershipCertificateDialog.actions'

const partnershipCertificateDialogState = {
  certificate: {},
  oldCertificate: false,
  error: false,
  loading: true
}

/**
 * The partnership certificate dialog' reducer.
 */
const partnershipsCertificateDialogReducer = (state = partnershipCertificateDialogState, { payload, type }) => {
  switch (type) {
    case GET_SELLER_PARTNERSHIP_CERTIFICATE: {
      return { ...state, loading: true }
    }
    case GET_SELLER_PARTNERSHIP_CERTIFICATE_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case GET_DATES_AWARDED_SUCCESS: {
      return { ...state, oldCertificate: payload.oldCertificate }
    }
    case GET_SELLER_PARTNERSHIP_CERTIFICATE_SUCCESS: {
      return { ...state, certificate: payload.certificate, loading: false }
    }
    case GET_DATES_AWARDED: {
      return { ...state, loading: true }
    }
    case GET_DATES_AWARDED_ERROR: {
      return { ...state, error: true, loading: false }
    }
    default: {
      return state
    }
  }
}

export default partnershipsCertificateDialogReducer
